export default __webpack_public_path__ + "static/media/zombie_assault_xmas.fc237cde.png";